import * as Immutable from "immutable";
import { createSelector } from "@reduxjs/toolkit";
import { widgetDefinition } from "views/logic/Widgets";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectSearchExecutionResult } from "views/logic/slices/searchExecutionSelectors";
import { selectActiveQuery, selectWidget } from "views/logic/slices/viewSelectors";
const _getDataAndErrors = (widget, widgetMapping, results) => {
  const { searchTypes } = results;
  const widgetType = widgetDefinition(widget.type);
  const dataTransformer = widgetType.searchResultTransformer || ((x) => x);
  const searchTypeIds = widgetMapping.get(widget.id, Immutable.Set());
  const widgetData = searchTypeIds.map((searchTypeId) => searchTypes[searchTypeId]).filter((result) => result !== void 0).toArray();
  const widgetErrors = results.errors.filter((e) => searchTypeIds.includes(e.searchTypeId));
  let error;
  const data = dataTransformer(widgetData);
  if (widgetErrors && widgetErrors.length > 0) {
    error = widgetErrors;
  }
  if (!widgetData || widgetData.length === 0) {
    const queryErrors = results.errors.filter((e) => e.type === "query");
    if (queryErrors.length > 0) {
      error = error ? [].concat(error, queryErrors) : queryErrors;
    }
  }
  return { widgetData: data, error };
};
const _getErrorsForQuery = (currentQueryId, currentQueryErrors) => {
  const queryError = currentQueryErrors == null ? void 0 : currentQueryErrors.find((searchError) => searchError.queryId === currentQueryId);
  return { widgetData: void 0, error: queryError ? [queryError] : [] };
};
const selectWidgetResults = (widgetId) => createSelector(
  selectSearchExecutionResult,
  selectActiveQuery,
  selectWidget(widgetId),
  (searchExecutionResult, currentQueryId, widget) => {
    var _a;
    const { result, widgetMapping } = searchExecutionResult != null ? searchExecutionResult : {};
    const currentQueryResults = (_a = result == null ? void 0 : result.results) == null ? void 0 : _a[currentQueryId];
    const currentQueryErrors = result == null ? void 0 : result.errors;
    return currentQueryResults ? _getDataAndErrors(widget, widgetMapping, currentQueryResults) : _getErrorsForQuery(currentQueryId, currentQueryErrors);
  }
);
const useWidgetResults = (widgetId) => useViewsSelector(selectWidgetResults(widgetId));
export default useWidgetResults;
